<script setup>
import { computed, ref, onUnmounted } from 'vue';
import { CustomMarker } from 'vue3-google-map';
import { usePageBrandStore } from '@stores/usePageBrandStore';
import { SELLER_BRAND_PREFIX } from '@tools/routes/routes';

const props = defineProps({
  pageSpace: {
    type: Object,
    required: true,
  },
  isSecondary: {
    type: Boolean,
    default: false,
  },
});

const position = computed(() => ({ lat: props.pageSpace.latitude, lng: props.pageSpace.longitude }));

const { setSelectedPageSpace } = usePageBrandStore();
const isHover = ref(false);
// @TODO Centralize in pinia store, see https://bureaux-a-partager.atlassian.net/browse/MATCH-9839
const isMobileOrTablet = ref(window.BREAKPOINTS.isMobile || window.BREAKPOINTS.isTablet);

const handleResize = () => {
  isMobileOrTablet.value = window.BREAKPOINTS.isMobile || window.BREAKPOINTS.isTablet;
};

window.addEventListener('resize', handleResize);
const handlePageSpaceSelection = (pageSpace) => {
  isHover.value = !!pageSpace;
  setSelectedPageSpace(pageSpace);
};
const openPageSpace = () => {
  const target = isMobileOrTablet.value ? '_self' : '_blank';

  window.open(`/${SELLER_BRAND_PREFIX}/${props.pageSpace.realSlug}`, target);
};

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});
</script>

<template>
  <CustomMarker :options="{ position, anchorPoint: 'BOTTOM_CENTER' }">
    <span
      :id="`marker-space-${props.pageSpace.id}`"
      class="map-marker marker-content"
      :class="{
        'hover': isHover,
        'bullet': props.isSecondary,
        'primary': !props.isSecondary,
      }"
      @mouseenter="handlePageSpaceSelection(props.pageSpace)"
      @mouseleave="handlePageSpaceSelection(null)"
      @click="openPageSpace"
    >
      {{ props.isSecondary && !isHover ? '' : props.pageSpace.title }}
    </span>
  </CustomMarker>
</template>
